import React, { Component } from 'react';
import "./style.css";

function Footer() {
    return (
        <div class="footer">
            <div class="row">
                &copy; James Pearce
            </div>
            <div class="row em">
                <a href="http://www.peculiarist.com/" target="__blank" alt="personal blog" >A Peculiarity Approaches</a>
            </div>
        </div>
    )
}

export default Footer;